module.exports = __webpack_public_path__ + "static/media/11_1.9e7d543f.jpg";